import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  class: "bg-white h-3 w-3 text-gray-400",
  fill: "none",
  viewBox: "0 0 12 12"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  class: "bg-white h-3 w-3 text-blue-600",
  fill: "currentColor",
  viewBox: "0 0 12 12"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" })
], -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 0,
  class: "ml-3",
  id: "annual-billing-label"
}
const _hoisted_7 = { class: "text-sm font-medium text-gray-900" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500", _ctx.value ? 'bg-blue-600' : 'bg-gray-200']),
      "aria-pressed": "false",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:value', !_ctx.value)))
    }, [
      _createElementVNode("span", {
        class: _normalizeClass(["pointer-events-none relative inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200", _ctx.value ? 'translate-x-5' : 'translate-x-0'])
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(["absolute inset-0 h-full w-full flex items-center justify-center transition-opacity", _ctx.value ? 'opacity-0 ease-out duration-100' : 'opacity-100 ease-in duration-200']),
          "aria-hidden": "true"
        }, _hoisted_3, 2),
        _createElementVNode("span", {
          class: _normalizeClass(["absolute inset-0 h-full w-full flex items-center justify-center transition-opacity", _ctx.value ? 'opacity-100 ease-in duration-200' : 'opacity-0 ease-out duration-100']),
          "aria-hidden": "true"
        }, _hoisted_5, 2)
      ], 2)
    ], 2),
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.label), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}